import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "top_tags"
};
var _hoisted_2 = {
  key: 0,
  class: "title"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  key: 1,
  class: "tip"
};
var _hoisted_5 = {
  class: "btns"
};
export default {
  __name: 'topTag',
  props: ['title', 'is_show_tip'],
  setup(__props) {
    var props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.title ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_3, [_renderSlot(_ctx.$slots, "title")]), __props.is_show_tip ? (_openBlock(), _createElementBlock("span", _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
};